<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    show-close
    width="500px"
    :title="title || defaultTitle"
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
  >
    <el-form
      ref="designForm"
      :model="formData"
      size="medium"
      label-width="125px"
      :rules="rules"
      style="margin-top: 30px;margin-bottom: 12px;"
    >
      <el-row :gutter="20">
        <el-col :span="22">
          <el-form-item
            :label="$l('INDEX.form_label_merchandiser') || '业务开发人员'"
            prop="merchandiserCode"
          >
            <dict-select
              v-model="formData.merchandiserCode"
              url="/master/common/dict/baseUserSelect"
              :selectedLabel.sync="formData.merchandiserName"
              clearable
              filterable
              size="medium"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button size="small" @click="close">{{
        $l('INDEX.btn_cancel') || '取消'
      }}</el-button>
      <el-button type="primary" size="small" @click="confirm()">{{
        $l('INDEX.product_dialog_btn_confirm') || '确定'
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  components: {},
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
  },
  data() {
    return {
      defaultTitle:
        this.$l('INDEX.dialog_title_adjust_merchandiser') || '业务开发人员调整',
      formData: { merchandiserCode: '', merchandiserName: '' },
      rules: {
        merchandiserCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_merchandiser') ||
              '请选择业务开发人员',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    async confirm() {
      const result = await validate.formValidate([this.$refs.designForm])
      if (!result) return
      this.$emit('confirm', this.formData)
    },
  },
}
</script>
